export const STATIC_HOST = `${process.env.REACT_APP_STATIC_HOST}`;
export const FRONT_HOST = `${process.env.REACT_APP_FRONT_HOST}`;